// 初始化 各自的数据图层索引
var layerIndex = {
  baseVector: [50001, 55000],
  baseVectorIndex: 50001,
  geoBound: [45001, 50000],
  geoBoundIndex: 45001,
  vector: [40001, 45000],
  vectorIndex: 40001,
  // 其他范围
  other: [10001, 40000],
  otherIndex: 10001,
  productImage: [9001, 10000],
  productImageIndex: 9001,
  baseImage: [8001, 9000],
  baseImageIndex: 8001,
  // 20910923 通道图下加入map 类型
  map: [7001, 8000],
  mapIndex: 7001
}

/**
 *  基于当前要添加的图层信息 获取当前图层应该在哪一层级显示的ZIndex
 * @param {*} layerInfo 需要添加的产品信息
 * @param {*} self  本插件自身
 */
function getZIndexByType (layerInfo) {
  // 若存在 zIndex 则使用zindex的数据
  // 如果存在 Zindex 则使用Zindex
  if (layerInfo.zIndex) {
    return layerInfo.zIndex
  }
  // TODO 超出阈值的处理

  let zIndexNum = 500
  const layerType = layerInfo.layerGroup
  switch (layerType) {
    case 'base': {
      // 自身绘制的图层 保留段位 50000-55000
      zIndexNum = layerIndex.baseVectorIndex
      layerIndex.baseVectorIndex = layerIndex.baseVectorIndex + 1
      break
    }
    case 'geoBound': {
      // A geoLayer 地理信息 段位 50000-55000 geoBound
      // geoBoundIndex: 50000,
      zIndexNum = layerIndex.geoBoundIndex
      layerIndex.geoBoundIndex = layerIndex.geoBoundIndex + 1
      break
    }
    case 'vector': {
      // B 可叠加的矢量图层 40000-45000
      // vectorIndex: 40000,
      zIndexNum = layerIndex.vectorIndex
      layerIndex.vectorIndex = layerIndex.vectorIndex + 1
      break
    }
    case 'other': {
      // C 自由增加减少的图层  10000-40000
      //    otherIndex: 10000,
      zIndexNum = layerIndex.otherIndex
      layerIndex.otherIndex = layerIndex.otherIndex + 1
      break
    }
    case 'productImage': {
      // D 产品图层  9000-10000
      // productImageIndex: 9000,
      zIndexNum = layerIndex.productImageIndex
      layerIndex.productImageIndex = layerIndex.productImageIndex + 1
      break
    }
    case 'map': {
      // E map图层 20190923
      // map  范围 mapIndex 8000,范围 8000-9000
      zIndexNum = layerIndex.mapIndex
      layerIndex.mapIndex = layerIndex.mapIndex + 1
      break
    }
    case 'baseImage': {
      // E 基础底图 7000-8000
      // baseImageIndex: 7000
      zIndexNum = layerIndex.baseImageIndex
      layerIndex.baseImageIndex = layerIndex.baseImageIndex + 1
      break
    }

    default: {
      // 所有未标识的图层都认为是自动添加图层
      // C 自由增加减少的图层  20000-40000
      // otherIndex: 10000,
      zIndexNum = layerIndex.otherIndex
      layerIndex.otherIndex++
      break
    }
  }
  return zIndexNum
}

export { getZIndexByType }
